var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("404 - Page not found :(")]),_c('hr'),_c('br'),_c('img',{attrs:{"src":require("../assets/404.png")}})])}]

export { render, staticRenderFns }